import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { ThemeService } from '../theme-service/theme.service';

@Component({
	selector: 'app-modal-confirm',
	templateUrl: './modal-confirm.component.html',
	styleUrls: ['./modal-confirm.component.styl'],
})
export class ModalConfirmComponent implements OnInit {

	public primaryColor: any;
	public title: string;
	public topText: string;
	public text: string;
	public backButton: string;
	public confirmButton: string;
	public hideBackButton: boolean;

	constructor(
		public dialogRef: MatDialogRef<ModalConfirmComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private themeService: ThemeService
	) {
		this.title = data.title ? data.title : '';
		this.text = data.text ? data.text : '';
		this.topText = data.topText ? data.topText : '';
		this.backButton = data.backButton ? data.backButton : 'Voltar';
		this.confirmButton = data.confirmButton ? data.confirmButton : 'Confirmar';
		this.hideBackButton = data.hideBackButton ? data.hideBackButton : false;
	}

	ngOnInit(): void {
		if (this.themeService.themeConfigs) {
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-confirm/modal-confirm.component.ts